import { render } from "./training-type-model.vue?vue&type=template&id=cdfef3a6"
import script from "./training-type-model.vue?vue&type=script&lang=js"
export * from "./training-type-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__